import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import api from '@/api/api'
import { dictionary } from '@/shared/services/dictionary';

import { Dialog } from 'vant';
import moment from 'moment';
import filter from '@/shared/services/filters';
@Component({
    filters: {
        formatDateMon: filter.formatDateMon,
        nullString: filter.nullString,
    },
})
export default class AddResumeEducationInfo extends Vue {
    @Prop() data: any; // 学历信息
    @Prop() inResume: any; // 是否在录用简历中
    educationList: any = []; // 学历数据源
    degreeList: any = []; // 学位数据源
    educationFormList: any = []; // 表单信息List
    educationForm: any = { // 表单信息
        collegeName: '',
        educateType: '',
        fullTimeOrNotName: '',
        specialtyName: '',
        rank: '',
        rankTotal: '',
        startTime: '',
        granduateDate: '',
        academicDegreeName: '',
    };
    educationRules: any = { // 表单验证
        collegeName: [
            { required: true, message: '请输入学校名称', trigger: 'blur' }
        ],
        educateType: [
            { required: true, message: '请选择学历', trigger: ['blur', 'change'] }
        ],
        fullTimeOrNotName: [
            { required: true, message: '请选择是否全日制', trigger: ['blur', 'change'] }
        ],
        specialtyName: [
            { required: true, message: '请输入所学专业', trigger: 'blur' }
        ],
        rank: [
            { required: true, message: '请输入专业成绩排名', trigger: 'blur' }
        ],
        rankTotal: [
            { required: true, message: '请输入排名总人数', trigger: 'blur' }
        ],
        startTime: [
            { required: true, message: '请选择入学年月', trigger: 'blur' }
        ],
        granduateDate: [
            { required: true, message: '请选择毕业年月', trigger: 'blur' }
        ],
        // academicDegreeName: [
        //     { required: true, message: '请选择学位', trigger: 'blur' }
        // ],
    };

    created() {
        // 学历获取
        this.getEducationList();
        // 学位获取
        this.getDegreeList();
        // 再次进入赋值
        if (this.data && this.data.educates && this.data.educates.length > 0) {
            this.educationFormList = this.data.educates.map((item: any) => {
                if (item.fullTimeOrNot !== null && item.fullTimeOrNot !== undefined) {
                    item.fullTimeOrNotName = (item.fullTimeOrNot === true ? '全日制' : (item.fullTimeOrNot === false ? '非全日制' : undefined));
                } else {
                    item.fullTimeOrNotName = null;
                }
                return item
            });
        }
    }

    // 监听简历信息变化
    @Watch('data')
    onDataChanged(val: any, oldVal: any) {
        if (val.educates && val.educates.length > 0) {
            this.educationFormList = val.educates.map((item: any) => {
                if (item.fullTimeOrNot !== null && item.fullTimeOrNot !== undefined) {
                    item.fullTimeOrNotName = (item.fullTimeOrNot ? '全日制' : (item.fullTimeOrNot === false ? '非全日制' : undefined));
                } else {
                    item.fullTimeOrNotName = null;
                }
                return item
            });
        }
    }

    // 获取学历数据源
    getEducationList() {
        api.getDictionaries([dictionary.educateType]).then((res: any) => {
            this.educationList = res.data || [];
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '数据获取失败：' + error,
            });
        });
    }

    // 获取学位数据源
    getDegreeList() {
        api.getDictionaries([dictionary.degreeType]).then((res: any) => {
            this.degreeList = res.data || [];
        }).catch((error: any) => {
            Dialog.alert({
                title: '提示',
                message: '数据获取失败：' + error,
            });
        });
    }

    // 更新input组件值，避免因组件嵌套太深出现input值未更新的情况
    updateInput() {
        this.$forceUpdate();
    }

    // 选择学位
    changeEducateType(event: any) {
        if (event) {
            this.educationForm.educateTypeId = event.id;
            this.educationForm.educateType = event.name;
        }
    }

    // 选择学位
    changeDegreeType(event: any) {
        if (event) {
            this.educationForm.academicDegreeId = event.id;
            this.educationForm.academicDegreeCode = event.code;
            this.educationForm.academicDegreeName = event.name;
        }
    }

    // 添加教育经历
    addExperience(formName: any) {
        const currentForm = JSON.parse(JSON.stringify(this.educationForm));
        (this as any).$refs[formName].validate((valid: any) => {
            if (valid) {
                if (moment(currentForm.granduateDate).isBefore(currentForm.startTime)) {
                    this.$message({
                        message: '毕业年月不可早于入学年月',
                        type: 'warning'
                    });
                    return
                }
                currentForm.fullTimeOrNot = (currentForm.fullTimeOrNotName === '全日制' ? true : (currentForm.fullTimeOrNotName === '非全日制' ? false : null));
                currentForm.rank = parseInt(currentForm.rank, 0);
                currentForm.rankTotal = parseInt(currentForm.rankTotal, 0);
                this.educationFormList.push(currentForm);
                (this as any).$refs[formName].resetFields();
                document.querySelector("#educate_title")?.scrollIntoView();
            } else {
                return false;
            }
        });
    }

    // 删除教育经历
    deleteExperience(index: any) {
        this.educationFormList.splice(index, 1);
    }

    // 上一步
    goBack() {
        const data = {
            currentStep: 3,
            move: 'back',
        };
        this.$emit('getRecruitInfo', data);
    }

    // 下一步
    goNext() {
        this.addExperience('educationForm');
        if (!this.educationFormList || this.educationFormList.length === 0) {
            this.$message({
                message: '请添加教育经历',
                type: 'warning'
            });
            return
        }
        const data = {
            currentStep: 3,
            move: 'next',
            fromInfo: this.educationFormList,
        };
        this.$emit('getRecruitInfo', data);
    }
}
